const HOST = `https://scalping-calculator-api.fullstack-freelancer.ru`;
export default HOST;
